module.exports = __webpack_public_path__ + "static/media/gender-female.9f8cfe1d.svg";